export enum PersonalDetailsFormField {
  AddProtectionPolicy = 'addProtectionPolicy',
  Address = 'address',
  GroupMarketingPreferences = 'groupMarketingPreferences',
  EmailAddress = 'emailAddress',
  FirstName = 'firstName',
  LastName = 'lastName',
  MarketingPreferenceEmail = 'marketingPreferenceEmail',
  MarketingPreferencePost = 'marketingPreferencePost',
  MarketingPreferenceTelephone = 'marketingPreferenceTelephone',
  PrivacyPolicy = 'privacyPolicy',
  TelephoneNumber = 'telephoneNumber',
  TitleId = 'titleId',
}
